import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "EventToolTestRideRegistration" })
export default class EventToolTestRideRegistration extends Vue {
    public isCreated: boolean = false;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public isAdult: boolean = false;
    public bookingExpirationDays: number = null;
    public isUnder18YearsOld: boolean = false;
    public formData: any = {
        isPassenger: false,
        birthCountry: "Italia",
        country: "Italy",
        birthDate: null,
        guardianBirthCountry: "Italia",
        guardianCountry: null,
        modelNameId: null,
        modelName: null,
        eventSlotId: null,
        taxCode: null,
        guardianTaxCode: null
    };
    public vehicleType: string = null;
    public countries: any[] = [];
    public taxCountries: any[] = [];
    public models: any[] = [];
    public eventSlots: any[] = [];
    public validationErrors: any[] = [];
    public testRiderId: string = null;

    @Prop() readonly eventIdMaster: string;
    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly page: string;
    @Prop() readonly returnPage: string;
    @Prop() readonly registrationToken: string;
    @Prop() readonly email: string;
    @Prop() readonly isBackend: boolean;

    @Watch('formData.modelName') onModelNameChanged(newValue: string, oldValue: string) {
        if (oldValue !== newValue) {
            this.eventSlots = [];
            if (this.isCreated) {
                this.formData.eventSlotId = null;
            }

            this.getEventSlotData();
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getData();
        this.isLoading = false;

        this.isCreated = true;
    }

    public async getData() {
        let data: any = { eventIdMaster: this.eventIdMaster, isBackend: this.isBackend };
        if (this.$route.query.hasOwnProperty("registrationtoken") && this.$route.query.hasOwnProperty("email")) {
            data.registrationtoken = <string>this.$route.query.registrationtoken;
            data.email = <string>this.$route.query.email;
        } else if (this.$route.query.hasOwnProperty("testriderid")) {
            data.testRiderId = <string>this.$route.query.testriderid;
            this.testRiderId = <string>this.$route.query.testriderid;
        } else if (this.registrationToken && this.email) {
            data.registrationtoken = this.registrationToken;
            data.email = this.email;
        }

        const response = (await Axios.post(this.routes.EventToolEvent_GetEventDetailData, data)).data;

        this.models = response.models;
        this.countries = response.countries;
        this.taxCountries = response.taxCountries;
        this.isAdult = response.isAdult;
        this.bookingExpirationDays = response.bookingExpirationDays;

        if (response.testRide?.registrationToken) {
            if (!this.testRiderId) {
                this.formData.registrationtoken = response.testRide.registrationToken;
                this.formData.modelName = response.testRide.modelName;
                this.formData.eventSlotId = response.testRide.eventSlotId;

                let model = this.models.find(x => x.name === response.testRide.modelName);
                if (model) {
                    this.selectModel(model);
                }
            }

            this.formData.name = response.testRide.name;
            this.formData.surname = response.testRide.surname;
            this.formData.birthDate = response.testRide.birthDate.split('T')[0];
            this.formData.birthCountry = response.testRide.birthCountry;
            this.formData.birthLocation = response.testRide.birthLocation;
            this.formData.gender = response.testRide.gender;
            this.formData.taxCode = response.testRide.taxCode;
            this.formData.address = response.testRide.address;
            this.formData.location = response.testRide.location;
            this.formData.cap = response.testRide.cap;
            this.formData.country = response.testRide.country;
            this.formData.email = response.testRide.email;
            this.formData.phone = response.testRide.phone;
            this.formData.raceLicenceNumber = response.testRide.raceLicenceNumber;
            this.formData.driverLicenseNumber = response.testRide.driverLicenseNumber;
            this.formData.driverLicenseExpirateDate = response.testRide.driverLicenseExpirateDate?.split('T')[0];
            this.formData.isPassenger = response.testRide.isPassenger;

            if (response.testRide.guardianName) {
                this.formData.guardianName = response.testRide.guardianName;
                this.formData.guardianSurname = response.testRide.guardianSurname;
                this.formData.guardianBirthDate = response.testRide.guardianBirthDate.split('T')[0];
                this.formData.guardianBirthCountry = response.testRide.guardianBirthCountry;
                this.formData.guardianBirthLocation = response.testRide.guardianBirthLocation;
                this.formData.guardianGender = response.testRide.guardianGender;
                this.formData.guardianTaxCode = response.testRide.guardianTaxCode;
                this.formData.guardianAddress = response.testRide.guardianAddress;
                this.formData.guardianLocation = response.testRide.guardianLocation;
                this.formData.guardianCAP = response.testRide.guardianCAP;
                this.formData.guardianCountry = response.testRide.guardianCountry;
                this.formData.guardianEmail = response.testRide.guardianEmail;
                this.formData.guardianPhone = response.testRide.guardianPhone;
            }

            this.checkIsUnder18YearsOld(this.formData.birthDate);
        }
    }

    public async getEventSlotData() {
        const response = (await Axios.post(this.routes.EventToolEvent_GetEventSlotData, { eventIdMaster: this.eventIdMaster, modelName: this.formData.modelName, isBackend: this.isBackend, registrationToken: this.formData?.registrationtoken })).data;
        this.eventSlots = response.eventSlots;
    }

    public selectModel(model: any) {
        if (!model.isAvailablility) { return; }

        this.formData.modelName = model.name;
        this.vehicleType = model.type;
    }

    public checkIsUnder18YearsOld(birthdateString: string): boolean {
        if (!birthdateString) return false;

        const [year, month, day] = birthdateString.split('-').map(Number);
        const birthdate = new Date(year, month - 1, day);
        const currentDate = new Date();

        birthdate.setFullYear(birthdate.getFullYear() + 18);

        this.isUnder18YearsOld = birthdate > currentDate;

        this.validationErrors = [];
        if (this.isUnder18YearsOld && this.isAdult) {
            this.validationErrors.push({ name: "BirthDate", message: "Evento solo per maggiorenni, non puoi iscriverti!" });
        }

        return this.isUnder18YearsOld;
    }

    public async calculateTaxCode(user: string) {
        let taxCodeForm = {
            name: this.formData.name,
            surname: this.formData.surname,
            birthDate: this.formData.birthDate,
            birthCountry: this.formData.birthCountry,
            birthLocation: this.formData.birthLocation,
            gender: this.formData.gender
        };

        if (user === "guardian") {
            taxCodeForm = {
                name: this.formData.guardianName,
                surname: this.formData.guardianSurname,
                birthDate: this.formData.guardianBirthDate,
                birthCountry: this.formData.guardianBirthCountry,
                birthLocation: this.formData.guardianBirthLocation,
                gender: this.formData.guardianGender
            };
        }

        try {
            const result = (await Axios.post(this.routes.Profile_GetTaxCode, taxCodeForm)).data;
            if (user === "guardian") {
                this.formData.guardianTaxCode = result.taxCode;
            } else {
                this.formData.taxCode = result.taxCode;
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.formData.eventIdMaster = this.eventIdMaster;
        this.formData.modelNameId = this.models.find(x => x.name === this.formData.modelName)?.idMaster;
        if (this.formData.isPassenger) {
            this.formData.raceLicenceNumber = null;
            this.formData.driverLicenseNumber = null;
            this.formData.driverLicenseExpirateDate = null;
        }

        if (this.recaptchaSiteKey) {
            (<any>window).grecaptcha.enterprise.ready(async () => {
                const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

                try {
                    await Axios.post(this.routes.EventToolEvent_EventDetailSubscribe, this.formData, { headers: { "RecaptchaVerificationToken": token } });

                    this.isSuccess = true;

                    if (this.page === "Manage") {
                        location.reload();
                    }
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                    }
                }
            });
        } else {
            try {
                const result = (await Axios.post(this.routes.EventToolBackend_TestRide_Modify, this.formData)).data;

                window.location.href = result.returnurl;
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoadingForm = false;
    }

    public newRegistration() {
        window.location.href = this.routes.EventToolEvent_EventDetail;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }

    public profiling(profiling: boolean) {
        this.formData.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.formData.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.formData.marketingChannels = marketingChannels;
    }

    public closeDialog() {
        this.$store.commit("eventToolStore/setIsRegistrationVisible", false);
    }
};